<div class="module-wrapper content-wrapper">
  <div class="tab-container">
    <mat-card>
      <mat-card-content>
        <div class="head-container">
          <div class="pageTitle">
            <h1>{{'testId.heading' | translate}}</h1>
            <!-- <div (mouseover)="isHidden = true">
              <img class="trainingIcon" src="../../../assets/favicon/video.png">
            </div>

            <div class="popupHover">
              <ng-container *ngIf="isHidden">
                <div class="hideshow">
                  <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
                </div>
              </ng-container>
            </div> -->
          </div>
          <div class="bread-crumb">
            <div class="breadcrumb-container">
              <a [routerLink]="[]" class="link-active" (click)="navigatetoTest()">{{'testId.nav1' | translate}}</a> /
              <span class="nav-link" *ngIf="tab1">{{tab}}</span>
              <span class="nav-link" *ngIf="!tab1">{{'testId.nav2' | translate}}</span>
            </div>
          </div>
          <span class="spacer"></span>
          <span class="message" *ngIf="(creditsAvailable > 0 && creditsAvailable <= perOfTestCredits) && display && isPublished">
            <strong>{{'testId.testCreditLow' | translate}}</strong></span>
            <span class="red" *ngIf="creditsAvailable === 0 && display && isPublished"><mat-icon>error</mat-icon><strong>{{'testId.testCreditConsumed' | translate}}</strong></span>
        </div>
        <div class="item-info-container">
          <div class="itemDetail">
            <div class="item-name"><span>{{'testId.labelName' | translate}}: {{testTitle}}</span>
            </div>

            <div class="item-desc">{{'testId.labelDesc' | translate}}: {{testDescription}} </div>
          </div>
          <span class="spacer"></span>
          <div class="edit-btn-wrapper">
            <span class="item-active" *ngIf="itemBasicDetails.statusName !== ''">
              <i-feather name="disc"></i-feather>
              <span>{{itemBasicDetails.statusName}}</span>
            </span>
            <div class="btn-wrapper">
              <button mat-icon-button aria-label="Edit Test"
                [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true) || (itemStatusId && itemStatusId !== testStatusList[1].itemStatusId)"
                matTooltip="{{'testId.toolTip.edit' | translate}}" matTooltipPosition="above" (click)="openEditTestDialog()" class="edit">
                <span class="menu-icon">
                  <i-feather name="edit"></i-feather>
                </span>
              </button>
            </div>
          </div>
        </div>
        <mat-tab-group mat-align-tabs="end" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onChange($event)" animationDuration="0ms">
          <mat-tab label="{{'testId.tabs.tab1' | translate}}">
            <ng-template mat-tab-label>
              <span class="menu-icon">
                <mat-icon>list</mat-icon>
              </span>
              <span>{{'testId.tabs.tab1' | translate}} ({{isTestItemCount}})</span>
            </ng-template>
            <div class="tab-content">
              <ng-container *ngIf="selectedTabIndex == 0 then testsItem"></ng-container>
              <ng-template #testsItem>
                <app-tests-items [tabData]='tabData' [testDetails]='dataOfTestDetails' [isPublished]='isPublished'></app-tests-items>
              </ng-template>
            </div>
          </mat-tab>

          <mat-tab label="{{'testId.tabs.tab2' | translate}}">
            <ng-template mat-tab-label>
              <span class="menu-icon"><i-feather name="tag"></i-feather></span>
              <span>{{'testId.tabs.tab2' | translate}}</span>
            </ng-template>
            <div class="tab-content">
              <ng-container *ngIf="selectedTabIndex == 1 then tags"></ng-container>
              <ng-template #tags>
                <app-tests-tags [tabData]='tabData' [isPublished]='isPublished' [item]='dataOfTestDetails'></app-tests-tags>
              </ng-template>
            </div>
          </mat-tab>
          <mat-tab label="{{'testId.tabs.tab3' | translate}}">
            <ng-template mat-tab-label>
              <span class="menu-icon">
                <mat-icon>schedule</mat-icon>
              </span>
              <span>{{'testId.tabs.tab3' | translate}}</span>
            </ng-template>
            <div class="tab-content">
              <ng-container *ngIf="selectedTabIndex == 2 then schedules"></ng-container>
              <ng-template #schedules>
                <app-tests-schedule *ngIf="testBankId" [testuuId]='testUUID' [testBankId]='testBankId' [isPublished]='isPublished'></app-tests-schedule>
              </ng-template>
            </div>
          </mat-tab>
          <mat-tab label="{{'testId.tabs.tab4' | translate}}">
            <ng-template mat-tab-label>
              <span class="menu-icon">
                <mat-icon>settings</mat-icon>
              </span>
              <span>{{'testId.tabs.tab4' | translate}}</span>
            </ng-template>
            <div class="tab-content">
              <ng-container *ngIf="selectedTabIndex == 3 then settings"></ng-container>
              <ng-template #settings>
                <app-tests-settings [tabData]='tabData' [testDetails]='dataOfTestDetails'
                (isTestDetails)="callTestDetails($event)"></app-tests-settings>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>

